'use strict';

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * set the height of the container
 */
function storeItemsHeight() {
    var viewSize = $(window).width();

    if (viewSize < 992) {
        var modalHeight = $('#storesStock .modal-content').innerHeight() - ($('#storesStock .modal-header').outerHeight() + $('.store-items').position().top + 60);
        $(document).find('.store-items').css('height', modalHeight);
    }
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.store-availability-results');

    if (data.accessPointsArray.storesResultsHtml) {
        $resultsDiv.empty().append(data.accessPointsArray.storesResultsHtml);

        storeItemsHeight();
    }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
    var spinner = $.spinner();
    spinner.start();
    var $form = element.closest('.store-availability');
    var radius = '';
    var url = $form.attr('action');
    var urlParams = { radius: radius };
    var pid = $('.product-wrapper').data('pid');

    var payload = {
        postalCode: $form.find('[name="postalCode"]').val(),
        pid: pid
    };

    url = appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
        }
    });
    return false;
}

/**
 * @description Show geolocation error
 * @param {string} type type of error
 */
function showGeolocatorError(type) {
    var errorBlock = $('.js-storelocator-postcode-error');
    errorBlock.html(errorBlock.data(type));
}

/**
 * Search for stores with new zip code
 * @param {Object} suggestResult - suggest result from google
 * @param {Object} geometryObject - geometry object from google
 */
function searchStores(suggestResult, geometryObject) {
    var spinner = $.spinner();
    var geometry = suggestResult.geometry || geometryObject;
    spinner.start();

    var $form = $('#store-postal-code').closest('.store-availability');
    var url = $form.attr('action');
    var pid = $('.product-wrapper').data('pid');

    $('.js-storelocator-postcode-error').html('');

    var endpointUrl = appendToUrl(url, {
        lat: geometry.location.lat(),
        long: geometry.location.lng(),
        pid: pid
    });

    $.ajax({
        url: endpointUrl,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
        }
    });
}

$(window).resize(function () {
    if ($('.store-availability-results .store-items').length > 0) {
        storeItemsHeight();
    }
});

module.exports = {
    init: function () {
        let initGoogleHandlers = require('../common/googleEvents');
        var $target = $('#store-postal-code');

        initGoogleHandlers($target, {
            isSkipAddingEvents: true,
            errorField: $('js-storelocator-postcode-error'),
            myLocationBtn: $('.detect-store-stock-location'),
            handleAddress: searchStores,
            showGeolocatorError: showGeolocatorError
        });
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-store-stock-location').on('click', function () {
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            navigator.geolocation.getCurrentPosition(function (position) {
                var $detectLocationButton = $('.detect-store-stock-location');
                var url = $detectLocationButton.data('action');
                var pid = $('.product-wrapper').data('pid');
                var urlParams = {
                    pid: pid,
                    lat: position.coords.latitude,
                    long: position.coords.longitude
                };

                url = appendToUrl(url, urlParams);
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        updateStoresResults(data);
                    }
                });
            });
        });
    },

    search: function () {
        $(document).on('click', '.store-stock-search[type="button"]', function (e) {
            e.preventDefault();
            search($(this));
        });

        $(document).on('keypress', '.store-page-inp', function (e) {
            if (e.keyCode === 13) {
                search($('.store-stock-search'));
            }
        });
    },

    openStockModal: function () {
        $('#storesStock').on('show.bs.modal', function () {
            $('#store-postal-code').val('');
            $('.store-availability-results').empty();
        });
    }
};
